import React from "react"
import { connect } from "react-redux"
import { actions } from '../modules/CaregiversAssignment'
import { drawerActions } from 'store/drawer'
import Loader from 'components/D3Loader'
import CaregiverAssignmentPage from "../components/CaregiverAssignmentPage"

const mapStateToProps = (state, ownProps) => {
    const { studyVersionID } = ownProps?.params || {}

    const { study, participants, loading } = state

    const caregiverDataFields = study?.currentStudy?.config?.caregiver_data_fields
    const caregiversList = Object.values(participants?.caregivers?.caregiversAssignment || {})

    return {
        ...state,
        studyVersionID,
        loading: loading.caregiver_assignment,
        caregiverDataFields,
        caregiversList
    }
}

const mapDispatchToProps = {
    ...actions,
    ...drawerActions
}

const CaregiverAssignmentContainer = props => {
    if (props.loading) {
        return <Loader />
    }
    return <CaregiverAssignmentPage {...props} />
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CaregiverAssignmentContainer)
